<template src="./rateOverrideDetailSummary.template.html"></template>
<script>
import moment from "moment-timezone";
export default {
  name: "rateOverrideDetailSummary",
  props: ["ratesDetailObj", "tapChartCallback","hideDetailSummary"],
  data() {
    return {
      propertyList: [],
      unitList: [],
      rateOverrideDetails: {
        propertyId: -1,
        unitId: -1,
        startDate: null,
        endDate: null,
        weekdayBaseRate: null,
        weekdayRatePerAddAdult: null,
        weekdayRatePerAddChild: null,
        weekendBaseRate: null,
        weekendRatePerAddAdult: null,
        weekendRatePerAddChild: null
      },
      opens: "right",
      rateId: null,
      showRatesDetail: true
    };
  },
  methods: {
    updateValues(values) {
      this.rateOverrideDetails.startDate = values.startDate
        .toISOString()
        .slice(0, 10);
      this.rateOverrideDetails.endDate = values.endDate
        .toISOString()
        .slice(0, 10);
    },
    getPropertyMetaData: function() {
      // let scope = this;
      // this.$store.dispatch("dataRequestHandler", {
      //     key: "GetPropertyMetaData",
      //     params: {
      //         ModuleAction: "GetPropertyMetaData",
      //     },
      //     callback: function (err, response) {
      //         if (response) {
      //             console.log("response GetPropertyMetaData", response);
      //             scope.propertyList.splice(0, scope.propertyList.length, ...response.recordsets[1]);
      //         } else {
      //             console.log(err);
      //         }
      //     }
      // });
      let vm = this;
      vm.$store.dispatch("dataRequestHandler", {
        key: "GetPropertiesBySearchText",
        params: {},
        callback: function(err, response) {
          if (err) {
            return;
          }
          if (response) {
            vm.propertyList.splice(
              0,
              vm.propertyList.length,
              ...response.propertyList
            );
          }
        }
      });
    },
    getPropertyUnits() {
      let scope = this;
      this.$store.dispatch("dataRequestHandler", {
        key: "GetUnitList",
        params: {
          PropertyId: scope.rateOverrideDetails.propertyId,
          StatusId: 1
        },
        callback: function(err, response) {
          if (response) {
            scope.unitList.splice(
              0,
              scope.unitList.length,
              ...response.recordsets[1]
            );
          } else {
            console.log(err);
          }
        }
      });
    },
    getRateOverrideDetailById() {
      let scope = this;
      scope.$store.dispatch("dataRequestHandler", {
        key: "GetRateDetailById",
        params: {
          RateId: scope.rateId
        },
        callback: function(err, response) {
          if (response) {
            if (response.recordsets[0][0]) {
              // scope.rateOverrideDetails = response.recordsets[0][0]
              scope.rateOverrideDetails.startDate =
                response.recordsets[0][0].DateEffective;
              scope.rateOverrideDetails.endDate =
                response.recordsets[0][0].DateEffective;
            }

            if (
              response.recordsets[0][0] &&
              response.recordsets[0][0].isWeekEnd == 0
            ) {
              scope.rateOverrideDetails.weekdayRatePerAddAdult =
                response.recordsets[0][0].AdditionalAdultRate;
              scope.rateOverrideDetails.weekdayRatePerAddChild =
                response.recordsets[0][0].AdditionalChildRate;
              scope.rateOverrideDetails.weekdayBaseRate =
                response.recordsets[0][0].BaseRate;
              scope.rateOverrideDetails.propertyId =
                response.recordsets[0][0].PropertyId;
              scope.rateOverrideDetails.unitId =
                response.recordsets[0][0].UnitId;
            } else if (
              response.recordsets[0][0] &&
              response.recordsets[0][0].isWeekEnd == 1
            ) {
              scope.rateOverrideDetails.weekendRatePerAddAdult =
                response.recordsets[0][0].AdditionalAdultRate;
              scope.rateOverrideDetails.weekendRatePerAddChild =
                response.recordsets[0][0].AdditionalChildRate;
              scope.rateOverrideDetails.weekendBaseRate =
                response.recordsets[0][0].BaseRate;
              scope.rateOverrideDetails.propertyId =
                response.recordsets[0][0].PropertyId;
              scope.rateOverrideDetails.unitId =
                response.recordsets[0][0].UnitId;
            }
            console.log(
              "response in rateOverrideDetails",
              scope.rateOverrideDetails
            );
            scope.getPropertyUnits();
          } else {
            console.log("error in rateOverrideDetails", err);
            return;
          }
        }
      });
    },
    saveRateOverrideDetails() {
      let scope = this;
      if (
        scope.rateOverrideDetails.propertyId == -1 ||
        scope.rateOverrideDetails.propertyId == null
      ) {
        scope.$store.dispatch("toastr", {
          type: "error",
          header: "Validations failed!",
          message: "Please select Property"
        });
        return;
      } else if (
        scope.rateOverrideDetails.unitId == -1 ||
        scope.rateOverrideDetails.unitId == null
      ) {
        scope.$store.dispatch("toastr", {
          type: "error",
          header: "Validations failed!",
          message: "Please select Unit"
        });
        return;
      }
      // else if (scope.rateOverrideDetails.weekdayBaseRate == null) {
      //     scope.$store.dispatch("toastr", {
      //         type: "error",
      //         header: "Validations failed!",
      //         message: "0"
      //     });
      //     return;
      // }
      else if (
        scope.rateOverrideDetails.endDate === "" ||
        scope.rateOverrideDetails.endDate === undefined ||
        scope.rateOverrideDetails.endDate === null ||
        scope.rateOverrideDetails.startDate === "" ||
        scope.rateOverrideDetails.startDate === undefined ||
        scope.rateOverrideDetails.startDate === null
      ) {
        scope.$store.dispatch("toastr", {
          type: "warning",
          header: "Warning!",
          message: "Please Select Start and End dates"
        });
        return;
      }

      let startDate = moment(scope.rateOverrideDetails.startDate).format(
        "YYYY-MM-DD"
      );
      let endDate = moment(scope.rateOverrideDetails.endDate).format(
        "YYYY-MM-DD"
      );
      for (
        let m = moment(startDate);
        m.diff(endDate, "days") <= 0;
        m.add(1, "days")
      ) {
        console.log("date", m.format("YYYY-MM-DD"));
        let date = new Date(m.format("YYYY-MM-DD"));
        console.log("date", date);
        console.log("day", date.getDay());
        if (date.getDay() == 0 || date.getDay() == 6) {
          if (!scope.rateOverrideDetails.weekendBaseRate) {
            scope.$store.dispatch("toastr", {
              type: "error",
              header: "Validations failed!",
              message: "Base Rate for Weekend is required"
            });
            return;
          } else if (
            scope.rateOverrideDetails.weekendBaseRate &&
            (parseInt(scope.rateOverrideDetails.weekendBaseRate) == 0 ||
              parseInt(scope.rateOverrideDetails.weekendBaseRate) < 0)
          ) {
            console.log("negative");
            scope.$store.dispatch("toastr", {
              type: "error",
              header: "Validations failed!",
              message: "Base Rate for Weekend should not be negative or zero"
            });
            return;
          } else if (
            (scope.rateOverrideDetails.weekendRatePerAddAdult &&
              parseInt(scope.rateOverrideDetails.weekendRatePerAddAdult) < 0) ||
            (scope.rateOverrideDetails.weekendRatePerAddChild &&
              parseInt(scope.rateOverrideDetails.weekendRatePerAddChild) < 0)
          ) {
            scope.$store.dispatch("toastr", {
              type: "error",
              header: "Validations failed!",
              message:
                "Additonal Rates for Weekend should not be negative or zero"
            });
            return;
          }
        } else {
          if (!scope.rateOverrideDetails.weekdayBaseRate) {
            scope.$store.dispatch("toastr", {
              type: "error",
              header: "Validations failed!",
              message: "Base Rate for Weekday is required"
            });
            return;
          } else if (
            scope.rateOverrideDetails.weekdayBaseRate &&
            (parseInt(scope.rateOverrideDetails.weekdayBaseRate) == 0 ||
              parseInt(scope.rateOverrideDetails.weekdayBaseRate) < 0)
          ) {
            console.log("negative");
            scope.$store.dispatch("toastr", {
              type: "error",
              header: "Validations failed!",
              message: "Base Rate for Weekday should not be negative or zero"
            });
            return;
          } else if (
            (scope.rateOverrideDetails.weekdayRatePerAddAdult &&
              parseInt(scope.rateOverrideDetails.weekdayRatePerAddAdult) < 0) ||
            (scope.rateOverrideDetails.weekdayRatePerAddChild &&
              parseInt(scope.rateOverrideDetails.weekdayRatePerAddChild) < 0)
          ) {
            scope.$store.dispatch("toastr", {
              type: "error",
              header: "Validations failed!",
              message:
                "Additonal Rates for Weekday should not be negative or zero"
            });
            return;
          }
        }
      }

      //         console.log("scope.rateOverrideDetails", scope.rateOverrideDetails)
      //         if( (scope.rateOverrideDetails.weekdayBaseRate > 0 &&
      //         scope.rateOverrideDetails.weekdayBaseRate != 0)){

      // }
      scope.$store.dispatch("dataRequestHandler", {
        key: "SaveRateOverrideDetails",
        // params: scope.rateOverrideDetails,
        params: {
          propertyId: scope.rateOverrideDetails.propertyId,
          unitId: scope.rateOverrideDetails.unitId,
          startDate: moment(scope.rateOverrideDetails.startDate).format(
            "YYYY-MM-DD"
          ),
          endDate: moment(scope.rateOverrideDetails.endDate).format(
            "YYYY-MM-DD"
          ),
          weekdayBaseRate: scope.rateOverrideDetails.weekdayBaseRate,
          weekdayRatePerAddAdult:
            scope.rateOverrideDetails.weekdayRatePerAddAdult,
          weekdayRatePerAddChild:
            scope.rateOverrideDetails.weekdayRatePerAddChild,
          weekendBaseRate: scope.rateOverrideDetails.weekendBaseRate,
          weekendRatePerAddAdult:
            scope.rateOverrideDetails.weekendRatePerAddAdult,
          weekendRatePerAddChild:
            scope.rateOverrideDetails.weekendRatePerAddChild
        },
        callback: function(err, response) {
          if (response) {
            console.log("saved rate override details", response);
            scope.$store.dispatch("toastr", {
              type: "success",
              header: "Success!",
              message: "Rate override details saved successfully"
            });
            if (scope.tapChartCallback) {
              scope.tapChartCallback();
            }
          } else {
            console.log(err);
            scope.$store.dispatch("toastr", {
              type: "error",
              header: "Rate override details Error!",
              message: err.sqlMessage ? err.sqlMessage : err
            });
          }
        }
      });
    },
    updateStartDate(key, dateObj) {
      let scope = this;
      scope.rateOverrideDetails.startDate = dateObj
        ? dateObj.format("DD MMM YYYY")
        : null;
    },
    updateEndDate(key, dateObj) {
      let scope = this;
      scope.rateOverrideDetails.endDate = dateObj
        ? dateObj.format("DD MMM YYYY")
        : null;
    },
    cancelRatesDetails() {
      let scope = this;
      // this.$router.push("/restrictionList");
      scope.showRatesDetail = false;
      scope.rateOverrideDetails = {
        propertyId: -1,
        unitId: -1,
        startDate: null,
        endDate: null,
        weekdayBaseRate: null,
        weekdayRatePerAddAdult: null,
        weekdayRatePerAddChild: null,
        weekendBaseRate: null,
        weekendRatePerAddAdult: null,
        weekendRatePerAddChild: null
      };
      if (scope.hideDetailSummary) {
        scope.hideDetailSummary();
      }
    }
  },
  computed: {},
  watch: {
    ratesDetailObj: {
      handler: function(resObj, oldVal) {
        if (resObj) {
          this.rateId = resObj.rateOverRideId;
          this.showRatesDetail = true;
          this.rateOverrideDetails = {
            propertyId: -1,
            unitId: -1,
            startDate: null,
            endDate: null,
            weekdayBaseRate: null,
            weekdayRatePerAddAdult: null,
            weekdayRatePerAddChild: null,
            weekendBaseRate: null,
            weekendRatePerAddAdult: null,
            weekendRatePerAddChild: null
          };
          this.getRateOverrideDetailById();
        }
      },
      deep: true
    }
  },
  mounted() {
    let vm = this;
    console.log("Rate Override module loaded");
    vm.getPropertyMetaData();
    vm.getRateOverrideDetailById();
    console.log("Rate Override module loaded");
  }
};
</script>